import ActionTypes from './../common/ActionTypes';

const firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');
require('firebase/functions');

const moment = require('moment');

const QUERY_LIMIT = 10;

let recentConnectActivityFetched = false;
let recentConnectActivitySnapshot;
let lastDocument;

function setLoading(loading) {
  return {
    type: ActionTypes.PROJECTS_CONNECT_ACTIVITY_LOADING,
    loading,
  };
}

function setLoadingMore(loading) {
  return {
    type: ActionTypes.PROJECTS_CONNECT_ACTIVITY_LOADING_MORE,
    loading,
  };
}

function setFailed(isFailed) {
  return {
    type: ActionTypes.PROJECTS_CONNECT_ACTIVITY_FAILED,
    isFailed,
  };
}

function setHasMore(hasMore) {
  return {
    type: ActionTypes.PROJECTS_CONNECT_ACTIVITY_HAS_MORE,
    hasMore,
  };
}

function recentConnectActivityCreated(connectActivity) {
  return {
    type: ActionTypes.PROJECTS_CONNECT_ACTIVITY_CREATED,
    connectActivity,
  };
}

function clearRecentConnectActivity() {
  return {
    type: ActionTypes.PROJECTS_CONNECT_ACTIVITY_CLEAR,
  };
}

function stopSync() {
  if (recentConnectActivitySnapshot) {
    recentConnectActivitySnapshot();
  }
}

function shouldUseAsLastDocument(timestamp) {
  return (
    !lastDocument ||
    moment(lastDocument.data().timestamp).isAfter(moment(timestamp))
  );
}

function fetchProjectConnectActivity() {
  return dispatch => {
    const { currentUser } = firebase.auth();
    if (currentUser) {
      recentConnectActivityFetched = false;
      lastDocument = null;
      dispatch(setLoading(true));
      dispatch(setFailed(false));
      dispatch(clearRecentConnectActivity());

      stopSync();

      recentConnectActivitySnapshot = firebase
        .firestore()
        .collection('projectActivity')
        .where('ownerUid', '==', currentUser.uid)
        .orderBy('timestamp', 'desc')
        .limit(QUERY_LIMIT)
        .onSnapshot(
          snapshot => {
            snapshot.docChanges().forEach(change => {
              const changeType = change.type;
              const connectActivity = change.doc.data();
              connectActivity.id = change.doc.ref.id;

              if (shouldUseAsLastDocument(connectActivity.timestamp)) {
                lastDocument = change.doc;
              }

              if (changeType === 'added') {
                dispatch(recentConnectActivityCreated(connectActivity));
              }
            });

            if (!recentConnectActivityFetched) {
              dispatch(setLoading(false));
              dispatch(setFailed(false));
              dispatch(setHasMore(snapshot.size === QUERY_LIMIT));
            }

            recentConnectActivityFetched = true;
          },
          () => {
            if (!recentConnectActivityFetched) {
              dispatch(setLoading(false));
              dispatch(setFailed(true));
            }
          },
        );
    }
  };
}

function fetchMoreProjectConnectActivity() {
  return dispatch => {
    const { currentUser } = firebase.auth();
    if (currentUser && lastDocument) {
      dispatch(setLoadingMore(true));

      recentConnectActivitySnapshot = firebase
        .firestore()
        .collection('projectActivity')
        .where('ownerUid', '==', currentUser.uid)
        .orderBy('timestamp', 'desc')
        .limit(QUERY_LIMIT)
        .startAfter(lastDocument)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            const connectActivity = doc.data();
            connectActivity.id = doc.ref.id;

            if (shouldUseAsLastDocument(connectActivity.timestamp)) {
              lastDocument = doc;
            }

            dispatch(recentConnectActivityCreated(connectActivity));
          });

          dispatch(setHasMore(snapshot.size === QUERY_LIMIT));
          dispatch(setLoadingMore(false));
        })
        .catch(() => {
          dispatch(setLoadingMore(false));
        });
    }
  };
}

export const projectConnectActivityActions = {
  fetchProjectConnectActivity,
  stopSync,
  fetchMoreProjectConnectActivity,
};



// WEBPACK FOOTER //
// ./src/actions/projectConnectActivity.js